<template>
  <v-text-field
    :rules="rules"
    v-bind="fieldProps"
    class="rounded-0"
    placeholder="Usuário"
    autocomplete="off"
    hide-details
    name="user"
    solo
  ></v-text-field>
</template>

<script>
import { requiredValidation } from "../validations/requiredValidation";
import { mixin } from "./mixin";

export default {
  data: () => ({
    rules: [requiredValidation("Digite seu usuário.")],
  }),
  mixins: [mixin],
};
</script>
